export const VERSION = {
  PROD: 'V. 3.9.0',
  QA: 'V. 5.9.9 (QA)',
}
